import { QueryClient } from '@tanstack/react-query';

export function createAppQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });
}

export const queryClient = createAppQueryClient();

export function clearSessionQueries() {
  queryClient.setQueryData(['auth', 'profile'], null);
  queryClient.removeQueries({ queryKey: ['auth', 'companies'] });
  queryClient.removeQueries({ queryKey: ['companies', 'my'] });
}
